import { PaginationState } from 'app/shared/pagination/pagination.model';

export const createInitPagination = (sortingColumn: string, direction?: string): PaginationState => {
  return {
    page: 1,
    size: 10,
    total: 0,
    column: sortingColumn,
    direction: direction ?? 'asc',
  };
};
export const createInitPaginationWithInitSize = (sortingColumn: string, initSize: number): PaginationState => {
  return {
    page: 1,
    size: initSize,
    total: 0,
    column: sortingColumn,
    direction: 'asc',
  };
};

export const renderPaginationFooter = (pagination: { page: number; size: number; total: number }) => {
  let startNumber = 0;
  let endNumber = pagination?.total;

  if (pagination?.total !== 0) {
    startNumber = (pagination?.page - 1) * pagination?.size + 1;
  }
  if (pagination?.total > pagination?.page * pagination?.size) {
    endNumber = pagination.page * pagination.size;
  }

  return startNumber + ' - ' + endNumber + ' od ' + pagination?.total;
};

export const getPaginationFilter = (paginationKey: string) => {
  return JSON.parse(localStorage.getItem(`${paginationKey}-filter-form`));
};

